/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_GamesInputs */

const th_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมที่คุณเป็นกรรมการ`)
};

const en_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Games you are refereeing`)
};

const ja_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたが審判を務める試合`)
};

const zh_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你执法的比赛`)
};

const es_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partidos que arbitras`)
};

const pt_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos que você apita`)
};

const id_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertandingan yang Anda pimpin`)
};

const fr_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les matchs que vous arbitrez`)
};

const tl_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga larong pinamumunuan mo`)
};

const vi_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các trận bạn cầm còi`)
};

const ko_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내가 맡은 경기`)
};

const de_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spiele, die du pfeifst`)
};

const ru_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Матчи, которые вы судите`)
};

const tr_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yönettiğiniz maçlar`)
};

const it_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le partite che arbitri`)
};

const pl_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mecze, które sędziujesz`)
};

const uk_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Матчі, які ви судите`)
};

const hi_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वे मैच जिनमें आप रेफ़री हैं`)
};

const ar_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المباريات التي تديرها`)
};

const ms_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perlawanan yang anda kendalikan`)
};

const bn_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনি যেসব খেলায় রেফারি`)
};

const zh_tw2_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你執法的比賽`)
};

const zh_hk2_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你執法的比賽`)
};

const ur_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وہ میچ جن کے آپ ریفری ہیں`)
};

const fa_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بازی‌هایی که داوری می‌کنید`)
};

const sw_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Michezo unayoichezesha`)
};

const nl_your_games = /** @type {(inputs: Your_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedstrijden die jij fluit`)
};

/**
* | output |
* | --- |
* | "Games you are refereeing" |
*
* @param {Your_GamesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const your_games = /** @type {((inputs?: Your_GamesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_GamesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_your_games(inputs)
	if (locale === "ja") return ja_your_games(inputs)
	if (locale === "zh") return zh_your_games(inputs)
	if (locale === "es") return es_your_games(inputs)
	if (locale === "pt") return pt_your_games(inputs)
	if (locale === "id") return id_your_games(inputs)
	if (locale === "fr") return fr_your_games(inputs)
	if (locale === "tl") return tl_your_games(inputs)
	if (locale === "vi") return vi_your_games(inputs)
	if (locale === "ko") return ko_your_games(inputs)
	if (locale === "de") return de_your_games(inputs)
	if (locale === "ru") return ru_your_games(inputs)
	if (locale === "tr") return tr_your_games(inputs)
	if (locale === "it") return it_your_games(inputs)
	if (locale === "pl") return pl_your_games(inputs)
	if (locale === "uk") return uk_your_games(inputs)
	if (locale === "hi") return hi_your_games(inputs)
	if (locale === "ar") return ar_your_games(inputs)
	if (locale === "ms") return ms_your_games(inputs)
	if (locale === "bn") return bn_your_games(inputs)
	if (locale === "zh-TW") return zh_tw2_your_games(inputs)
	if (locale === "zh-HK") return zh_hk2_your_games(inputs)
	if (locale === "ur") return ur_your_games(inputs)
	if (locale === "fa") return fa_your_games(inputs)
	if (locale === "sw") return sw_your_games(inputs)
	if (locale === "nl") return nl_your_games(inputs)
	return en_your_games(inputs)
});